import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import MarkdownRenderer from '../components/MarkdownRenderer';
import './Home.css';

const Home = () => {
  const { isAdmin } = useAuth();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const response = await axios.get('/api/posts');
      setPosts(response.data);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch posts');
      setLoading(false);
    }
  };
  const formatDate = (dateString) => {
    return dateString.split(' ')[0];
  }
  const handleDelete = async (postId) => {
    if (!isAdmin) {
      alert('只有管理员才能删除文章');
      return;
    }

    if (window.confirm('Are you sure you want to delete this post?')) {
      try {
        await axios.delete(`/api/posts/${postId}`);
        setPosts(posts.filter(post => post.id !== postId));
      } catch (err) {
        if (err.response?.status === 401) {
          alert('权限不足，请先登录管理员账户');
        } else {
          setError('Failed to delete post');
        }
      }
    }
  };

  // 获取文章摘要，支持Markdown格式
  const getPostExcerpt = (content, maxLength = 80) => {
    // 移除Markdown标记符号来计算长度
    const plainText = content.replace(/[#*`_~\[\]()]/g, '').replace(/\n+/g, ' ');
    if (plainText.length <= maxLength) {
      return content;
    }
    
    // 在Markdown中寻找合适的截断点
    const truncated = content.substring(0, maxLength);
    const lastSentence = truncated.lastIndexOf('。');
    const lastNewline = truncated.lastIndexOf('\n');
    const cutPoint = Math.max(lastSentence, lastNewline);
    
    return cutPoint > 30 ? content.substring(0, cutPoint + 1) : truncated + '...';
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="home">
      <div className="container">
        {/* <div className="hero-section">
          <h1>欢迎来到我的博客</h1>
          <p>分享技术心得，记录学习历程 | 支持 Markdown 格式</p>
        </div> */}
        
        <div className="posts-section">
          <div className="section-header">
            <h2>最新文章</h2>
            {/* 只有管理员才能看到写新文章按钮 */}
            {isAdmin && (
              <Link to="/create" className="btn btn-primary">写新文章</Link>
            )}
          </div>
          
          {posts.length === 0 ? (
            <div className="no-posts">
              <p>还没有文章{isAdmin && (
                <>，<Link to="/create">写第一篇文章</Link></>
              )}</p>
            </div>
          ) : (
            <div className="posts-grid">
              {posts.map(post => (
                <article key={post.id} className="post-card">
                  <div className="post-header">
                    <h3>
                      <Link to={`/post/${post.id}`} className="post-title">
                        {post.title}
                      </Link>
                    </h3>
                    <div className="post-meta">
                      <div className="post-meta-left">
                        {/*<span className="author">作者: {post.author}</span>*/}
                        <span className="date">{formatDate(post.created_at)}</span>
                      </div>
                      {isAdmin && <span className="view-count">阅读量: {post.view_count || 0}</span>}
                    </div>
                  </div>
                  
                  <div className="post-content">
                    <MarkdownRenderer 
                      content={getPostExcerpt(post.content)}
                      className="post-excerpt"
                    />
                  </div>
                  
                  <div className="post-footer">
                    <div className="tags">
                      {post.tags.map((tag, index) => (
                        <span key={index} className="tag">#{tag}</span>
                      ))}
                    </div>
                    <div className="post-actions">
                      <Link to={`/post/${post.id}`} className="btn btn-outline">
                        阅读更多
                      </Link>
                      {/* 只有管理员才能看到删除按钮 */}
                      {isAdmin && (
                        <button 
                          onClick={() => handleDelete(post.id)}
                          className="btn btn-danger"
                        >
                          删除
                        </button>
                      )}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;